export const SUPPORTS_OBJECT_FROM_ENTRIES = "fromEntries" in Object;
